module.exports = __webpack_public_path__ + "img/activity_21.321fb3a9.jpg";